import { client } from '@/client';
import { isNotEmptyJSONStr, isVoid } from '@/utils/common';

export function getDictList(params) {
  return client.post('/api/sys_dictionary_service/page-query', params);
}

export function deleteDict(id) {
  return client.delete(`/api/sys_dictionary_service/delete/${id}`);
}

export function addDict(params) {
  return client.post('/api/sys_dictionary_service/create', params);
}

export function updateDict(params) {
  return client.post('/api/sys_dictionary_service/update', params);
}

/** 兼容老字典 */
// 部署方式字典
export function getAllDeployEnvs() {
  return client.get('/api/console/dictionary/getAllDeployEnvs');
}

export function getAllBKVersions() {
  return client.get('/api/console/dictionary/getAllBKVersions');
}

export function getClusterUsage() {
  return client.get('/api/console/dictionary/getClusterUsage');
}

export function getAllZKVersions() {
  return client.get('/api/console/dictionary/getAllZKVersions');
}

export function getAllDeployVersions() {
  return client.get('/api/console/dictionary/getAllDeployVersions');
}

export function getAllPulsarVersions() {
  return client.get('/api/console/dictionary/getAllPulsarVersions');
}

export function getAllKafkaVersions() {
  return client.get('/api/console/dictionary/getAllKafkaVersions');
}

export function getPermissions() {
  return client.get('/api/console/dictionary/getPermissions');
}

export function getBacklogRetentionPolicy() {
  return client.get('/api/console/dictionary/getBacklogRetentionPolicy');
}

// Schema 兼容策略
export function getSchemaPolicy() {
  return client.get('/api/console/dictionary/getSchemaPolicy');
}

// 获取字典详情
export async function getDictDetailByKey(key) {
  const { data } = await client.get('/api/sys_dictionary_service/detailByKey', {
    key,
  });
  if (isVoid(data)) {
    return null;
  }
  const { dictValue } = data;
  return isNotEmptyJSONStr(dictValue) ? JSON.parse(dictValue) : dictValue;
}

// 根据key更新字典
export async function updateDictByKey(params) {
  return client.post('/api/sys_dictionary_service/updateByKey', params);
}
